var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:`btn btn-${_vm.variant}`,attrs:{"type":"button","disabled":_vm.loading},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.loading)?_c('i',{staticClass:"fas fa-sync-alt fa-spin fa-lg me-3"}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }